/**
 * De "NU"-markering voor de momenten waarop er géén les loopt: vóór het eerste uur,
 * tijdens een pauze, en na het laatste uur.
 *
 * Loopt er wél een les, dan draagt díe kaart de markering — groene rand, resterende
 * minuten en een voortgangsbalk (zie LesKaart). Deze regel is dus wat er overblijft
 * voor de gaten in de dag, en houdt het scherm ook dán bij "u bent hier".
 */
export function NuLijn() {
  return (
    <div className="now-line">
      <div className="pill">
        <span className="dot" />
        NU
      </div>
      <div className="line" />
    </div>
  );
}
